import InsuranceCompanyCollectionView from 'scripts/defa/insurance-companies/view-insurance-company-collection-view';
import ActiveContainer                from 'scripts/poppet/active-container';
import template                       from 'templates/insuranceCompanyContainer.jst.html';

const selectors = {
	container   : '[data-region=selection-container]',
	checkService: '[data-input=selection-service]',
};

/**
 * defa.views.InsuranceCompanyContainer
 * The Layout for dispatching unit claims.
 * @version 1.2.0
 */
const InsuranceCompanyContainer = ActiveContainer.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	className: 'card',
	
	ui: {
		service: selectors.checkService,
	},
	
	regions: {
		container: selectors.container,
	},
	
	events: {
		'change @ui.service': 'onChangeService',
	},
	
	templateContext: function () {
		return {
			yearlyService: this.options.yearlyService,
		};
	},
	
	
	// ------------------------------------------------
	// Event handlers
	// ------------------------------------------------
	
	/**
	 * constructor
	 */
	initialize: function ( options ) {
		// if yearlyService isn't set, then it should be true.
		if ( _.isUndefined( options.yearlyService ) ) {
			options.yearlyService = true;
		}
		
		ActiveContainer.prototype.initialize.call( this, options );
	},
	
	/**
	 * Triggers when a user clicks the service checkbox.
	 * @void
	 */
	onChangeService: function () {
		this.trigger( 'insuranceCompany:service', this.ui.service.is( ':checked' ) );
	},
	
	/**
	 * Triggers when a childView is selected.
	 * @void
	 */
	onChildviewSelected: function ( childView ) {
		this.selected = childView.model.get( 'id' );
		this.enableSubmit();
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Attaches the collection view of radio buttons for selection.
	 * @void
	 */
	attachView: function () {
		let insuranceCompanyCollectionView = new InsuranceCompanyCollectionView( {
			collection: this.collection,
		} );
		
		this.showChildView( 'container', insuranceCompanyCollectionView );
	},
	
	/**
	 * Submits the form.
	 * @void
	 */
	submit: function () {
		this.trigger( 'insuranceCompany:selected', this.selected );
	},
	
} );


export default InsuranceCompanyContainer;